module.exports = __webpack_public_path__ + "img/countries-icons.2da04795.svg";